var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPtimeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65562",
    "data-name": "Grupo 65562",
    transform: "translate(-792 -784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_15497",
    "data-name": "Ret\\xE2ngulo 15497",
    transform: "translate(792 784)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65553",
    "data-name": "Grupo 65553",
    transform: "translate(4203 6557.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95641",
    "data-name": "Caminho 95641",
    d: "M21.19,642.96a.94.94,0,0,1-.94-.93v-1.32a.94.94,0,0,1,1.87,0v1.32a.929.929,0,0,1-.93.93Zm-17.44-.93v-6.89a3.751,3.751,0,0,1,3.75-3.75H9.23a.94.94,0,0,0,0-1.88H7.5a5.631,5.631,0,0,0-5.62,5.63v6.89a.94.94,0,0,0,1.87,0ZM24,647.42a2.81,2.81,0,0,0-2.81-2.81H2.81a2.81,2.81,0,1,0,0,5.62H21.19A2.81,2.81,0,0,0,24,647.42Zm-2.81-.94a.94.94,0,0,1,0,1.87H2.81a.94.94,0,0,1,0-1.87Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95642",
    "data-name": "Caminho 95642",
    d: "M22.19,628.06a6.2,6.2,0,0,0-10.59,4.41v5.2a.919.919,0,0,0,.58.86.888.888,0,0,0,1-.2l.09-.08a1.492,1.492,0,0,1,1.73-.29,6.067,6.067,0,0,0,2.75.65,6.193,6.193,0,0,0,4.42-10.55Zm-4.42,8.67a4.182,4.182,0,0,1-1.91-.45,3.48,3.48,0,0,0-1.5-.35,3.6,3.6,0,0,0-.87.11v-3.57a4.31,4.31,0,1,1,4.31,4.27Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#38d2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPtimeicon);
export default __webpack_public_path__ + "static/media/LPtimeicon.8f8cd1bf7b49cf089b29c910f3d39a2b.svg";
export { ForwardRef as ReactComponent };